export const projects = [
  {
    title: "Portfolio",
    description:
      "Using React, JavaScript and Tailwind CSS to come up with a beautiful portfolio.",
    image: ".../../images/portfolio.png",
    tags: ["React", "JavaScript", "Tailwind CSS"],
    visit: "https://github.com/sangwaniKondowe/Portfolio.git",
    source: "https://sangwanimkondowe.netlify.app",
    id: 0,
  },
  {
    title: "IBMS: Backend",
    description:
      "Using Node.js, Express.js and Postgresql to come up with a web based API.",
    image: ".../../images/github.png",
    tags: ["Node.js", "Express.js", "Postgresql"],
    source: "https://github.com/sangwaniKondowe/backend.git",
    visit: "https://github.com/sangwaniKondowe/backend.git",
    id: 1,
  },
];

export const list = [
  {
    title: "Intervention and Beneficiary Management System (IBMS)",
    description:
      "A final year project and I was tasked to implement the backend.",
    startdate: "January 28th, 2022",
    enddate:"May 2nd, 2022",
    id: 0,
  },
  {
    title: "Portifolio",
    description:
      "Built to showcase my skills in the web development arena.",
    startdate: "December 3, 2022",
    enddate:"January 3, 2023",
    id: 1,
  },
];
